/**
 * Client-side region detection for pricing.
 * India has exactly one timezone (Asia/Kolkata / Asia/Calcutta) so this is reliable.
 */
export function detectRegion() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  const isIndia = tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta';
  return {
    isIndia,
    symbol: isIndia ? '₹' : '$',
    price: isIndia ? '99' : '9.99',
    originalPrice: isIndia ? '199' : '12.00',
    currency: isIndia ? 'INR' : 'USD',
    subtext: isIndia
      ? '(was ₹199/mo)'
      : '(India: ₹99/mo · was $12.00)',
  };
}
